import { render } from "./labe_bar.vue?vue&type=template&id=2487143b&scoped=true"
import script from "./labe_bar.vue?vue&type=script&lang=js"
export * from "./labe_bar.vue?vue&type=script&lang=js"

import "./labe_bar.vue?vue&type=style&index=0&id=2487143b&scoped=true&lang=scss"
import "./labe_bar.vue?vue&type=style&index=1&id=2487143b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2487143b"]])

export default __exports__